<script>
import Page from '@/components/elements/Page';
import { detect } from 'detect-browser';
import CcButton from '@/components/elements/CcButton';
// import { parseProofData, getDocument } from 'dcc-pdf-tools';
// import { QRSizeInCm } from '@/data/constants'

export default {
    name: 'PrintCW',
    components: { Page, CcButton },
    props: {
        type: {
            type: String,
            required: true
        },
        token: null,
        verificationCode: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            document: null,
            fetching: null
        }
    },
    computed: {
        browser() {
            return detect();
        },
        browserIsIE() {
            return this.browser.name === 'ie';
        },
        fileName() {
            return 'coronacheck.pdf';
        },
        metadata() {
            return {
                title: this.$t('pdf.metadata.title'),
                author: this.$t('pdf.metadata.author')
            };
        },
        proof() {
            return this.$store.state.qrs.proof;
        },
        hasDomestic() {
            return true // this.proof.domestic;
        },
        hasEuropean() {
            return false // this.proof.european;
        },
        pageType() {
            if (this.hasDomestic && this.hasEuropean) {
                return 'both';
            } else {
                if (this.hasDomestic) {
                    return 'domestic';
                } else {
                    return 'european';
                }
            }
        },
        endpoint() {
            switch (this.type) {
            case 'vaccination':
                return 'issueVacQrCode';
            case 'test':
                return 'issueTestQrCode';
            case 'recovery':
                return 'issueRecoveryQrCode';
            default:
                return 'issueVacQrCode';
            };
        },
        qrFilename() {
            switch (this.type) {
            case 'vaccination':
                return 'QRCodeVaxDCC.pdf';
            case 'test':
                return 'QRCodeTestDCC.pdf';
            case 'recovery':
                return 'QRCodeRecoveryDCC.pdf';
            default:
                return 'QRCodeVaxDCC'
            };
        }
    },
    methods: {
        getQRCode() {
            this.fetching = true;
            this.$axios
                .post(this.$config.apiacthealth + 'DccIssuances/' + this.endpoint, { token: this.token, code: this.verificationCode }, {
                    crossdomain: true,
                    responseType: 'blob',
                    headers: {
                        'Access-Control-Allow-Origin': '*',
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${this.$store.state.accToken}`
                    }
                })
                .then(response => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.target = '_blank';
                    fileLink.setAttribute('download', this.qrFilename);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.fetching = false;
                })
                .catch(error => {
                    this.fetching = false;
                    alert(error);
                    this.errored = true
                })
        },
        async createDocument() {
            // const holderConfig = this.$store.state.holderConfig;
            // const proofs = parseProofData(this.proof, holderConfig);
            // this.document = await getDocument(proofs, this.currentLanguage.locale, QRSizeInCm)
        },
        goBack() {
            this.$emit('back');
        },
        openPDF() {
            if (this.document) {
                const string = this.document.output('datauristring');
                const embed = '<embed width="100%" height="100%" src="' + string + '"/>';
                const action = window.open();
                action.document.open();
                action.document.write(embed);
                action.document.close();
                action.document.title = this.metadata.title;
            } else {
                this.somethingGeneralWentWrong();
            }
        },
        downloadPDF() {
            if (this.document) {
                this.document.save(this.fileName);
            } else {
                this.somethingGeneralWentWrong();
            }
        },
        somethingGeneralWentWrong() {
            const confirmAction = () => {
                this.$router.push({ name: 'ProvideCode' });
            }
            this.$store.commit('modal/set', {
                messageHead: this.$t('pdf.generalError'),
                messageBody: this.$t('pdf.message.error.general.body'),
                confirm: true,
                confirmAction,
                confirmYes: this.$t('pdf.goBackToStart'),
                confirmNo: this.$t('pdf.close')
            });
        }
    }
    // watch: {
    //     currentLanguage() {
    //         this.render()
    //     }
    // }
}
</script>

<template>
    <Page class="Print" @back="goBack">
        <div class="section">
            <slot></slot>
            <div class="section-block">
                <div class="Print__container">
                    <div
                        :class="{'browser-ie': browserIsIE}"
                        class="Print__buttons">
                        <CcButton
                            @select="getQRCode()"
                            id="open-pdf"
                            :disabled="false"
                            :label="$t('views.print.openPDF')"
                            :full-width="true"/>
                            <div v-text="$t('onemoment')" v-if="fetching" class="OnemomentText"></div>
                        <!-- <CcButton
                            @select="downloadPDF()"
                            id="download-pdf"
                            :disabled="!downloadPDF"
                            :label="$t('views.print.openPDF')"
                            :full-width="true"/> -->
                    </div>
                </div>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.Print {

    .Print__container {
        margin-top: $length-xl;
        display: flex;

        .Print__buttons {
            width: 212px;

            button {
                margin-bottom: $length-s;
            }

            #open-pdf {
                display: block;

                // hide the open button on mobile. This sometimes fails and besides that it creates undesirable user experience
                @include mobile() {
                  //  display: none;
                }

                @include mobile-landscape-X() {
                   // display: none;
                }
            }

            #download-pdf {
                display: none;

                @include mobile() {
                    display: block;
                }

                @include mobile-landscape-X() {
                    display: block;
                }
            }

            // &.browser-ie {

            //     #open-pdf {
            //        // display: none;
            //     }

            //     #download-pdf {
            //       //  display: block;
            //     }
            // }
        }

        .Print__image {
            width: calc(100% - 212px);
            display: flex;
            justify-content: flex-end;
            margin-top: -$length-s;

            img {
                width: 248px;
                margin-right: -$length-xl;
            }
        }
    }

    @include tablet() {

        .Print__container {

            .Print__image {

                img {
                    margin-right: 0;
                }
            }
        }
    }

    @include mobile() {

        .Print__container {
            display: block;

            .Print__buttons {
                margin-bottom: $length-xxl--mobile;
            }

            .Print__image {
                width: 100%;
                margin: 0;

                img {
                    margin: 0 auto;
                }
            }
        }
    }

    .Print__container {
        margin-top: $length-xl;
        display: flex;

    }

    .OnemomentText {
        display: block;
        margin: 20px;
        padding-block: 30px;
        font-weight: bold;
    }
}
</style>
